var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('div',{staticClass:"left"},[_c('span')]),_c('div',{staticClass:"right"},[_c('div',{staticStyle:{"margin-right":"16px"}},[_vm._v("版权所有:中国地震局地球物理研究所")]),_c('div',[_vm._v("技术支持:第四纪数字地球（北京）科技有限公司")])])])
}]

export { render, staticRenderFns }